export const negateNumber = (number: number | string) => {
  if (number === 0) {
    return 0;
  }
  return Number(number) * -1;
};
